<template>
  <v-row v-scroll="onScroll">
    <!-- header -->
    <mini-header title="Categorías" :breadcrumbs="breadcrumbs" :dense="true" :hiddenTab="true" :scroll="scroll">
      <template v-slot:main>
        <v-btn v-if="!isCurrentDefaultSegment" outlined @click="handleAddSuppliers"><v-icon left>mdi-account-plus</v-icon>Agregar proveedores</v-btn>
        <v-btn v-if="!isCurrentDefaultSegment" class="mx-2" outlined @click="openEditCategory"><v-icon left>mdi-pencil</v-icon>Editar</v-btn>
        <v-btn v-if="$store?.state?.auth?.account?.options?.includes('rec_process_rules')" outlined @click="dialogRules = true"><v-icon left>mdi-cog</v-icon>Configurar reglas</v-btn>
        <!-- <v-query-builder class="mx-2" :query-map="filters" model="suppliers" :active.sync="activeFilter" /> -->
      </template>
    </mini-header>
    <!-- end header -->

    <v-col cols="12" class="px-0 mt-20">
      <skeleton-list v-if="loading" />
      <template v-else>
        <SupplierList
          :suppliers-list="suppliersList"
          :show-category-column="false"
          empty-title="Agrega proveedores a esta categoría"
          @delete="handleDelete"
          @add="handleAdd"
          @change="handleChange"
        >
          <template v-slot:empty-actions>
            <v-btn v-if="!isCurrentDefaultSegment" outlined @click="handleAddSuppliers"><v-icon left>mdi-account-plus</v-icon>Agregar proveedores</v-btn>
          </template>
        </SupplierList>
      </template>
    </v-col>

    <!-- dialog confirm delete -->
    <SupplierDeleteCategoryModal
      v-model="dialogDelete"
      :supplier="currentItem"
      @confirm="handleDeleteConfirm"
    />
    <!-- end dialog confirm delete -->

    <!-- dialog add/change category -->
    <SupplierCategoryModal
      v-model="dialogAddCategory"
      :action-type="actionType"
      :supplier="currentItem"
      :categories-list="groupsList"
      :loading="createCategoryLoading"
      @confirm="handleCategoryConfirm"
    />
    <!-- end dialog add/change category -->

    <!-- Configure rules modal -->
    <ConfigureRulesModal
      v-model="dialogRules"
      :segment-id="$route.params.id"
      :rule-data="currentRuleData"
      @saved="handleRulesSaved"
    />
    <!-- end configure rules modal -->

    <!-- Edit category modal -->
    <v-dialog v-model="dialogEditCategory" width="650" persistent no-click-animation scrollable overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Editar categoría</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="dialogEditCategory = false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pb-4 pt-5 px-5" style="max-height: 600px !important;">
          <v-list class="pa-0 transparent v-list-form-card">
            <v-list-item class="pb-1">
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="editableCategory.name" outlined required single-line dense maxlength="100" hide-details placeholder="Escribe el nombre de la categoría"/>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Descripción</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="editableCategory.description" outlined required single-line dense maxlength="100" hide-details placeholder="Escribe una descripción de la categoría"/>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-5 py-2">
          <v-spacer />
          <v-btn outlined @click="dialogEditCategory = false">Cancelar</v-btn>
          <v-btn color="blue-500" @click="saveCategory" :loading="savingCategory" :disabled="!editableCategory.name.trim()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end edit category modal -->

  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import MiniHeader from '@/components/commons/MiniHeader'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import SkeletonList from '@/components/commons/skeletonLoader/SkeletonList'
import SupplierList from '@/modules/supplier/components/SupplierList'
import ConfigureRulesModal from '@/modules/supplier/components/ConfigureRulesModal'
import SupplierCategoryModal from '@/modules/supplier/components/SupplierCategoryModal'
import SupplierDeleteCategoryModal from '@/modules/supplier/components/SupplierDeleteCategoryModal'
import ListViewMixin from '@/mixins/ListViewMixin'
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  components: {
    VQueryBuilder,
    SkeletonList,
    SupplierList,
    MiniHeader,
    ConfigureRulesModal,
    SupplierCategoryModal,
    SupplierDeleteCategoryModal
  },
  mixins: [
    GenericViewMixin,
    ListViewMixin
  ],
  data: () => ({
    defaultSegmentId: 'se_AAAAAAAAAAAAAAAA',
    dialogRules: false,
    currentRuleData: null,
    dialogEditCategory: false,
    editableCategory: {
      name: '',
      description: ''
    },
    savingCategory: false,
    currentCategoryData: null,
    currentCategory: '',
    category: '',
    actionType: 'add',
    createCategoryLoading: false,
    dialogAddCategory: false,
    currentItem: {},
    menu: [false],
    idDelete: '',
    dialogDelete: false,
    activeFilter: false,
    scroll: 0,
    confirm: '',
    confirmChange: '',
    isAccept: false,
    dialogConfirm: false,
    current: {},
    filters: [
      {
        type: 'text',
        id: 'name',
        label: 'Nombre',
        value: null,
        category: 'a',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'tax_id',
        label: 'RUT',
        value: null,
        category: 'a',
        operators: [],
        countries: ['PE', 'CL']
      }
    ],
    dialogSupplier: false,
    loading: false,
    breadcrumbs: {
      main: 'Recepción',
      children: [
        {
          text: 'Categorías',
          route: 'SuppliersCategoriesList'
        },
        {
          text1: ''
        }
      ]
    }
  }),
  computed: {
    ...mapState({
      count: state => state.suppliers.suppliersCount,
      suppliersList: state => state.suppliers.suppliersList,
      countriesList: state => state.base.countriesList,
      membersList: state => state.accounts.membersList,
      groupsList: state => state.suppliers.segmentsList
    }),
    isDefaultSegment () {
      return (id) => id === this.defaultSegmentId
    },
    isCurrentDefaultSegment () {
      return this.$route.params.id === this.defaultSegmentId
    },
    filteredSegmentsList () {
      return this.groupsList.filter(segment =>
        segment.id !== this.defaultSegmentId &&
        segment.id !== this.currentItem?.segment_id
      )
    }
  },
  watch: {
    'newSupplier.country' () {
      this.newSupplier.state = ''
      this.newSupplier.tax_id = ''
    }
  },
  created () {
    this.getList()
  },
  methods: {
    handleRulesSaved () {
      this.currentRuleData = null
      this.getList()
    },
    openEditCategory () {
      this.editableCategory = {
        name: this.currentCategoryData?.name || '',
        description: this.currentCategoryData?.description || ''
      }
      this.dialogEditCategory = true
    },
    saveCategory () {
      if (!this.editableCategory.name.trim()) return

      this.savingCategory = true
      this.$store.dispatch('suppliers/UPDATE', {
        resource: `segments/${this.$route.params.id}`,
        payload: {
          name: this.editableCategory.name.trim(),
          description: this.editableCategory.description?.trim() || ''
        }
      })
      .then(() => {
        this.$dialog.message.info('La categoría ha sido actualizada con éxito.')
        this.breadcrumbs.children[1].text1 = this.editableCategory.name.trim()
        this.currentCategoryData = {
          ...this.currentCategoryData,
          name: this.editableCategory.name.trim(),
          description: this.editableCategory.description?.trim() || ''
        }
        this.dialogEditCategory = false
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.savingCategory = false
      })
    },
    handleAddSuppliers () {
      this.$router.push({
        name: 'SuppliersCategoriesAddSuppliers',
        params: { id: this.$route.params.id }
      })
    },
    handleDelete (item) {
      this.currentItem = item
      this.currentCategory = item.group_details?.name || 'Sin categoría asociada'
      this.dialogDelete = true
    },
    handleAdd (item) {
      this.currentItem = item
      this.handlerAddCategory('add')
    },
    handleChange (item) {
      this.currentItem = item
      this.handlerAddCategory('change')
    },
    handlerAddCategory (type) {
      this.actionType = type
      this.currentCategory = this.currentItem.group_details?.name ? this.currentItem.group_details.name : 'Sin categoría asociada'
      this.$store.dispatch('suppliers/LIST', {
        resource: 'segments',
        query: {
          page_size: 9999
        }
      })
      this.dialogAddCategory = true
    },
    async handleCategoryConfirm ({ supplier, newCategoryId, oldCategoryId, actionType }) {
      this.createCategoryLoading = true
      try {
        if (actionType === 'change') {
          await this.$store.dispatch('suppliers/UPDATE', {
            resource: `suppliers/${supplier.id}/replace-segment`,
            payload: {
              old_segment_id: oldCategoryId,
              new_segment_id: newCategoryId
            }
          })
        } else {
          await this.$store.dispatch('suppliers/UPDATE', {
            resource: `suppliers/${supplier.id}/replace-segment`,
            payload: {
              old_segment_id: this.defaultSegmentId,
              new_segment_id: newCategoryId
            }
          })
        }
        this.$dialog.message.info(actionType === 'change' ? 'La categoría ha sido cambiada correctamente.' : 'El proveedor ha sido asignado correctamente a la categoría.')
        this.getList()
      } catch (error) {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      } finally {
        this.dialogAddCategory = false
        this.createCategoryLoading = false
      }
    },
    onScroll (e) {
      this.scroll = e.target?.scrollingElement?.scrollTop ?? 0
    },
    handleDeleteConfirm ({ supplier, categoryId }) {
      this.$store.dispatch('suppliers/UPDATE', {
        resource: `suppliers/${supplier.id}/remove-segment`,
        payload: {
          segment_id: categoryId
        }
      })
      .then(() => {
        this.$dialog.message.info('El proveedor se ha eliminado de la categoría con éxito')
        this.getList()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.dialogDelete = false
      })
    },
    getList () {
      this.breadcrumbs.children[1].text1 = ''
      this.loading = true
      let currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      if (currentQuery.name) delete currentQuery.name
      this.$store.dispatch('suppliers/LIST', {
        resource: `suppliers/by-segment/${this.$route.params.id}`,
        query: currentQuery
      })
      .then((response) => {
        this.$store.commit('suppliers/SET_SUPPLIERS_LIST', response?.data?.results ?? response?.data ?? [])
      })
      .finally(() => {
        this.loading = false
      })
      this.$store.dispatch('suppliers/RETRIEVE', {
        resource: 'segments',
        id: this.$route.params.id
      })
      .then((response) => {
        const isDefault = this.$route.params.id === this.defaultSegmentId
        this.currentCategoryData = response.data
        this.currentRuleData = response.data
        this.breadcrumbs.children[1].text1 = isDefault ? 'Sin categoría' : (response.data?.name ?? 'Sin categoría asociada')
      })
      .catch(() => {
        const isDefault = this.$route.params.id === this.defaultSegmentId
        if (!this.breadcrumbs.children[1].text1) this.breadcrumbs.children[1].text1 = isDefault ? 'Sin categoría' : 'Sin categoría asociada'
      })
    }
  }
}
</script>
<style scoped>
.inf-alert-yellow.v-alert--outlined {
  border-color: var(--light-yellow-700) !important;
  background-color: var(--light-yellow-100) !important;
}
</style>
